import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "@/config/firebase";
import { log } from "@/utils/logger";
import { setCurrentUser } from "@/utils/helpers";

const useLogin = () => {
    const onLogin = async (email: string, password: string) => {
        try {
            const { user } = await signInWithEmailAndPassword(auth, email, password);
            await setCurrentUser(user);
        } catch (err) {
            log.error(err);
        }
    };

    return onLogin;
};

export { useLogin };
